/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(document).ready(function ($) {
  $('section .recommended-search').appendTo('.header__recommended-search');

  $('.announcement-bar__image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'anticipated',
    prevArrow:
      '<svg width="16" id="icon_previous" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.86175 7.56094L11.2622 0.180933C11.5047 -0.0607219 11.8973 -0.0603156 12.1393 0.182183C12.3812 0.424651 12.3806 0.817431 12.1381 1.05927L5.17809 8.00003L12.1383 14.9407C12.3808 15.1826 12.3814 15.5752 12.1396 15.8177C12.0182 15.9392 11.8593 16 11.7003 16C11.5417 16 11.3834 15.9396 11.2623 15.8189L3.86175 8.43909C3.74497 8.3229 3.67944 8.16478 3.67944 8.00003C3.67944 7.83528 3.74516 7.67734 3.86175 7.56094Z" fill="black"/></svg>',
    nextArrow:
      '<svg width="16" id="icon_next" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1382 7.56094L4.73778 0.180933C4.49531 -0.0607219 4.10275 -0.0603156 3.86069 0.182183C3.61881 0.424651 3.61944 0.817431 3.86194 1.05927L10.8219 8.00003L3.86169 14.9407C3.61922 15.1826 3.61859 15.5752 3.86044 15.8177C3.98178 15.9392 4.14075 16 4.29972 16C4.45828 16 4.61662 15.9396 4.73774 15.8189L12.1382 8.43909C12.255 8.3229 12.3206 8.16478 12.3206 8.00003C12.3206 7.83528 12.2548 7.67734 12.1382 7.56094Z" fill="black"/></svg>',
  });

  $('.section-blog .block-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:
      '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Next" disabled=""><svg width="16" id="icon_previous" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.86175 7.56094L11.2622 0.180933C11.5047 -0.0607219 11.8973 -0.0603156 12.1393 0.182183C12.3812 0.424651 12.3806 0.817431 12.1381 1.05927L5.17809 8.00003L12.1383 14.9407C12.3808 15.1826 12.3814 15.5752 12.1396 15.8177C12.0182 15.9392 11.8593 16 11.7003 16C11.5417 16 11.3834 15.9396 11.2623 15.8189L3.86175 8.43909C3.74497 8.3229 3.67944 8.16478 3.67944 8.00003C3.67944 7.83528 3.74516 7.67734 3.86175 7.56094Z" fill="black"/></svg></button>',
    nextArrow:
      '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg width="16" id="icon_next" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1382 7.56094L4.73778 0.180933C4.49531 -0.0607219 4.10275 -0.0603156 3.86069 0.182183C3.61881 0.424651 3.61944 0.817431 3.86194 1.05927L10.8219 8.00003L3.86169 14.9407C3.61922 15.1826 3.61859 15.5752 3.86044 15.8177C3.98178 15.9392 4.14075 16 4.29972 16C4.45828 16 4.61662 15.9396 4.73774 15.8189L12.1382 8.43909C12.255 8.3229 12.3206 8.16478 12.3206 8.00003C12.3206 7.83528 12.2548 7.67734 12.1382 7.56094Z" fill="black"/></svg></button>',
    responsive: [
      {
        breakpoint: 999,
        settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          arrows: false,
          infinite: true,
          slidesToShow: 2.5,
          slidesToScroll: 1.5,
        },
      },
    ],
  });
});

$(document).ready(function () {
  const table = $('.table-container');
  if (table) {
    $('.product-tab__technical .product-tab__inner').append(
      `<div class="table-container">${table.html()}</div>`
    );
    table.remove();
  }
});

// STICKY PRODUCT TAB

// REVIEW SCRIPT
document.addEventListener('DOMContentLoaded', function () {
  const pics = document.querySelectorAll(
    '.product-reviewd-container .jdgm-rev__pics'
  );
  if (pics.length > 0)
    pics.forEach((pic) => {
      const content = pic.innerHTML.trim();
      if (content !== '') {
        pic.parentNode.parentNode.append(pic);
      } else {
        pic.parentNode.parentNode.classList.add('no-pic');
      }
    });
});

// EXPAND CONTENT
document.addEventListener('DOMContentLoaded', function () {
  const expands = document.querySelectorAll('[data-action-expand]');
  expands.forEach((expand) => {
    expand.addEventListener('click', function () {
      expand.parentNode.setAttribute(
        'aria-expanded',
        expand.parentNode.getAttribute('aria-expanded') === 'true'
          ? 'false'
          : 'true'
      );
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const atc = $('[data-action="add-to-cart"]').click(function () {
    if (window.innerWidth < 640) {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: 0,
        },
        100
      );
    }
  });
});

// CHANGE PRICE IF COLOR SWATCH CLICK
$('.color-swatch').click(function () {
  const product_id = $(this).attr('data-product-id');
  const product_price = $(this).attr('data-variant-id');
  $(`.product-item__price-list[data-product-id="${product_id}"]`).html(
    `<span class="price"><span>${product_price}</span></span>`
  );
  const var_id = $(this).attr('data-var-id');
  const default_url = $('.default-url[data-product-id="' + product_id + '"]');
  const s = default_url.text().split('/products/');
  $(`.form-button__action a[data-product-id="${product_id}"]`).attr(
    'href',
    '/products/' + s[s.length - 1] + '?variant=' + var_id
  );
});

const initVariantClick = () => {
  $('.size-swatch').click(function () {
    const product_id = $(this).attr('data-product-id');
    const product_price = $(this).attr('data-variant-id');
    $(`.product-item__price-list[data-product-id="${product_id}"]`).html(
      `<span class="price"><span>${product_price}</span></span>`
    );
    const var_id = $(this).attr('data-var-id');
    const default_url = $('.default-url[data-product-id="' + product_id + '"]');
    const s = default_url.text().split('/products/');
    $(`.form-button__action a[data-product-id="${product_id}"]`).attr(
      'href',
      '/products/' + s[s.length - 1] + '?variant=' + var_id
    );

    // TOGGLE SELECTED
    $(
      '.list-sizes[data-product-id="' + product_id + '"] .size-swatch'
    ).removeClass('selected');

    // ADD CLASS SELECTED
    $(
      '.list-sizes[data-product-id="' +
        product_id +
        '"] .size-swatch[data-var-id="' +
        var_id +
        '"]'
    ).addClass('selected');
  });
};

$('.size-swatch').click(function () {
  const product_id = $(this).attr('data-product-id');
  const product_price = $(this).attr('data-variant-id');
  $(`.product-item__price-list[data-product-id="${product_id}"]`).html(
    `<span class="price"><span>${product_price}</span></span>`
  );
  const var_id = $(this).attr('data-var-id');
  const default_url = $('.default-url[data-product-id="' + product_id + '"]');
  const s = default_url.text().split('/products/');
  $(`.form-button__action a[data-product-id="${product_id}"]`).attr(
    'href',
    '/products/' + s[s.length - 1] + '?variant=' + var_id
  );

  // TOGGLE SELECTED
  $(
    '.list-sizes[data-product-id="' + product_id + '"] .size-swatch'
  ).removeClass('selected');

  // ADD CLASS SELECTED
  $(
    '.list-sizes[data-product-id="' +
      product_id +
      '"] .size-swatch[data-var-id="' +
      var_id +
      '"]'
  ).addClass('selected');
});

// SLIDE BUY WITH PRODUCT JQUERY
$(document).ready(function () {
  const target = $('product-grid__layout');
  const slide_left = $('.slide-right').on('click', function () {
    $('.product-grid__layout').animate({ scrollLeft: '+=300' });
  });
  const slide_right = $('.slide-left').on('click', function () {
    $('.product-grid__layout').animate({ scrollLeft: '-=300' });
  });
});

$(document).ready(function () {
  const slide_left = $('.product-thumbnail__slide .slide-right').on(
    'click',
    function () {
      $('.product-gallery__thumbnail-list').animate({
        scrollLeft: '+=300',
      });
    }
  );
  const slide_right = $('.product-thumbnail__slide .slide-left').on(
    'click',
    function () {
      $('.product-gallery__thumbnail-list').animate({
        scrollLeft: '-=300',
      });
    }
  );
});

// PRODUCT VARIANT IMAGE CLICK
/* document.addEventListener('DOMContentLoaded', function () {
  const variants = document.querySelectorAll(
    '[data-classes="special_classes"] .variant-swatch'
  );
  variants.forEach((current) => {
    current.addEventListener('click', () => {
      const media_id = current.getAttribute('data-media-id');
      const thumb = document.querySelector(
        '.product-gallery__thumbnail[data-media-id="' + media_id + '"]'
      );
      if (thumb) {
        thumb.click();
      }
    });
  });
});*/

function removeVietnameseTones(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
  str = str.replace(/đ/g, 'd');
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
  str = str.replace(/Đ/g, 'D');
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ''); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ''); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, ' ');
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
    ''
  );
  return str;
}

document.addEventListener('DOMContentLoaded', function () {
  const handles = document.querySelectorAll('[data-device-handle]');
  let array = [];
  handles.forEach((current) => {
    current.dataset.deviceStatus = removeVietnameseTones(
      current.dataset.deviceStatus
    );
    let child = {
      handle: current.dataset.deviceStatus,
      list: [],
    };
    array.push(child);
  });
  const link_handles = document.querySelectorAll('[data-image-handle]');
  link_handles.forEach((current) => {
    current.dataset.imageHandle = removeVietnameseTones(
      current.dataset.imageHandle
    );
    const Index = array.findIndex(
      (x) => x.handle === current.dataset.imageHandle
    );
    if (Index !== -1) {
      array[Index]['list'].push(current.dataset.mediaSpecialId);
    }
  });
  setTimeout(function () {
    const firstOption = document.querySelector(
      '.variant-swatch-list[data-classes="special_classes"] .variant-swatch[data-handle="special_classes"]'
    );
    const code = firstOption.querySelector('.variant-swatch__image')?.dataset
      .handleColor;
    $(`[data-image-handle="${code}"]`).css('display', 'inline-block');
    const buttons = document.querySelectorAll(
      '.variant-swatch-list[data-classes="special_classes"] .variant-swatch[data-handle="special_classes"]'
    );
    buttons.forEach((current) => {
      current.addEventListener('click', function () {
        $(`[data-image-handle]`).css('display', 'none');
        const cod = current.querySelector('.variant-swatch__image')?.dataset
          .handleColor;
        $(`[data-image-handle="${cod}"]`).css('display', 'inline-block');
      });
    });
  });
});

jQuery(document).ready(function ($) {
  $('.multicolumn-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    lazyLoad: 'anticipated',
    wrapAround: true,
    prevArrow:
      '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Next" disabled=""><svg width="16" id="icon_previous" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.86175 7.56094L11.2622 0.180933C11.5047 -0.0607219 11.8973 -0.0603156 12.1393 0.182183C12.3812 0.424651 12.3806 0.817431 12.1381 1.05927L5.17809 8.00003L12.1383 14.9407C12.3808 15.1826 12.3814 15.5752 12.1396 15.8177C12.0182 15.9392 11.8593 16 11.7003 16C11.5417 16 11.3834 15.9396 11.2623 15.8189L3.86175 8.43909C3.74497 8.3229 3.67944 8.16478 3.67944 8.00003C3.67944 7.83528 3.74516 7.67734 3.86175 7.56094Z" fill="black"/></svg></button>',
    nextArrow:
      '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg width="16" id="icon_next" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.1382 7.56094L4.73778 0.180933C4.49531 -0.0607219 4.10275 -0.0603156 3.86069 0.182183C3.61881 0.424651 3.61944 0.817431 3.86194 1.05927L10.8219 8.00003L3.86169 14.9407C3.61922 15.1826 3.61859 15.5752 3.86044 15.8177C3.98178 15.9392 4.14075 16 4.29972 16C4.45828 16 4.61662 15.9396 4.73774 15.8189L12.1382 8.43909C12.255 8.3229 12.3206 8.16478 12.3206 8.00003C12.3206 7.83528 12.2548 7.67734 12.1382 7.56094Z" fill="black"/></svg></button>',
  });
});

document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 640) {
    const $targets = document.querySelectorAll('.nav-bar__item--static');
    if ($targets && $targets.length > 0) {
      const element = document.createElement('li');
      element.className = 'nav-bar__item nav-bar__megaMobile';
      element.innerHTML =
        '<span class="nav-bar__link link" data-type="menu-item">Danh mục</span>';

      const childWrapper = document.createElement('div');
      childWrapper.className = 'nav-bar__megaContent';

      $targets.forEach((current) => {
        if (!current.classList.contains('nav__adv')) {
          childWrapper.append(current);
        }
      });

      element.append(childWrapper);

      const parentElement = document.querySelector('.nav-bar__linklist');
      parentElement.append(element);
    }
  }
});

$(document).ready(function () {
  $('.value-picker__choice-item').click(function () {
    const item = $(this).text();
    $('.value-picker__choice-item').removeClass('is-selected');
    $(this).addClass('is-selected');

    $('.value-picker-button span').text(item);
  });
});
